import { START_MINUTE_OF_DAY, TICKS_PER_GAME_MINUTE } from './constants';

export interface GameClock {
  /** 1-based day number. */
  day: number;
  hour: number;
  minute: number;
}

export function clockFromTime(time: number): GameClock {
  const totalMinutes = Math.floor(time / TICKS_PER_GAME_MINUTE) + START_MINUTE_OF_DAY;
  const minuteOfDay = totalMinutes % 1440;
  return {
    day: Math.floor(totalMinutes / 1440) + 1,
    hour: Math.floor(minuteOfDay / 60),
    minute: minuteOfDay % 60,
  };
}

/**
 * Fraction of the day in [0, 1), with sub-minute precision. For presentation only (lighting):
 * never feed it back into the simulation.
 */
export function dayFraction(time: number): number {
  const minutes = time / TICKS_PER_GAME_MINUTE + START_MINUTE_OF_DAY;
  return (minutes % 1440) / 1440;
}

/** Night: 22:00–06:00 (lights needed on the runway, night shifts on duty). */
export const NIGHT_START = 22 * 60;
export const NIGHT_END = 6 * 60;

export function minuteOfDay(time: number): number {
  return (Math.floor(time / TICKS_PER_GAME_MINUTE) + START_MINUTE_OF_DAY) % 1440;
}

export function dayIndex(time: number): number {
  return Math.floor((Math.floor(time / TICKS_PER_GAME_MINUTE) + START_MINUTE_OF_DAY) / 1440);
}

/** Whether a minute of the day (0–1439) falls in the night. */
export function isNightMinute(m: number): boolean {
  return m >= NIGHT_START || m < NIGHT_END;
}

export function isNight(time: number): boolean {
  return isNightMinute(minuteOfDay(time));
}
